import React, { useEffect, useState, useRef, ChangeEvent  } from "react";
import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from "react-tooltip";
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { getDropdownList, getDropdownValues, getLegalEntityMappings, getAdminDropdownValues } from '../../pages/newClientRequest/dropdownService';
import "./DropDownBlade.css";
import { ListBox } from 'primereact/listbox';
import { Toast } from 'primereact/toast';
import axios from "../../datasource/axios";
import { MANAGEDROPDOWN_URL} from '../../constants';
import { hideLoader } from "../../datasource/msal";
import { ConfirmToast } from "react-confirm-toast";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";
import { FilterMatchMode } from 'primereact/api';
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputSwitch } from 'primereact/inputswitch';
import { Stats } from "fs";
import { table } from "console";
import { ToggleSwitch } from './ToggleComponent';
  
export const DropDownBlade = (props:any) => { 

    const [selectedTable, setSelectedTable] = useState('');
    const [selectedTableName, setSelectedTableName] = useState('');
    const [selectedSegment, setSelectedSegment] = useState('');
    const [selectedSegmentValue, setSelectedSegmentValue] = useState({});
    const [selectedTableValue, setSelectedTableValue] = useState({});
    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const [lastValueText, setLastValueText] = useState("");
    const [addValueText, setAddValueText] = useState("");
    const [addMappingText, setAddMappingText] = useState("");
    const [dropdownTables, setDropdownTables] = useState([]);
    const [segments, setSegments] = useState([]);
    const [tableValues, setTableValues] =  useState<any[]>([]);
    const toast = useRef<any>(null); 
    const [newList, setNewList] = useState<any[]>([]);
    const [mappingList, setMappingList] = useState<any[]>([]);
    const [deletedList, setDeletedList] = useState<any[]>([]);
    const [selectedOption, setSelectedOption] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [spinnerClassName, setSpinnerClassName] = useState("");
    const [visible, setVisible] = useState(false);
    const [checked, setChecked] = useState(false);
    const [showCheckBox, setShowCheckBox] = useState(false);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [segmentDialogVisible, setSegmentDialogVisible] = useState(false);
    const [first, setFirst] = useState(0);
    const [statusList, setStatusList] = useState<any[]>([]);
    const [updateNow, setUpdateNow] = useState(true);
    const [filters, setFilters] = useState<DataTableFilterMeta>({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
        updatedDate: { value: null, matchMode: FilterMatchMode.EQUALS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
   
    const updateFunc = () => {
        setUpdateNow(!updateNow);
      }

    const loadSegmentDropDonwList = async () => {
        let response: any = await getDropdownValues("segments");
        let codes = response?.codes;
        setSegments(codes);
    }
 
    const loadDropDownList = async () => {
        let response: any = await getDropdownList();
        let codes = response?.codes;
        setDropdownTables(codes);
    }

    const onChange = async (e: { checked: any; }) => {
 
        if (e.checked) {
            setChecked(true);
            retrieveLegalEntityMappings();
        }
        else {
            setChecked(false);
             //retrieve list of values for selected table
            if (selectedTable === "legal_entities") {
                let response: any = await getLegalEntityMappings();
                let codes = response?.codes;
                setTableValues(codes);
            }else {
                let response: any = await getAdminDropdownValues(selectedTable);
                let codes = response?.codes;
                setTableValues(codes);
            }
        }
    }

    const onSegmentTableChange = async (e: { value: any}) => {
        let segment = e.value["code"];
        setSelectedSegment(segment);
        setSelectedSegmentValue(e.value);
        const addMappingText = e.value["name"];
        setAddMappingText(addMappingText);     
      }

    const onTableChange = async (e: { value: any}) => {
        clearForm();
        let tableName = e.value["code"];
        setSelectedTable(tableName);

        setSelectedTableValue(e.value);

        let displayName = e.value["name"];
        setSelectedTableName(displayName);
    
        //retrieve list of values for selected table
        if (tableName === "legal_entities") {
            let response: any = await getLegalEntityMappings();
            let codes = response?.codes;
            setTableValues(codes);
            let templist = [];
            for (let i = 0; i < codes.length; i++) {
                var rowDetails = {
                    'id': codes[i].name,
                    'status': codes[i].status
                };
                statusList[i] = rowDetails;
            }
        } else {
            let response: any = await getAdminDropdownValues(tableName);
            let codes = response?.codes;
             setTableValues(codes);
            let templist = [];
            for (let i = 0; i < codes.length; i++) {
                var rowDetails = {
                    'id': codes[i].name,
                    'status': codes[i].status
                };
                statusList[i] = rowDetails;
            }
        }
    }

     const retrieveLegalEntityMappings = async () => {
        let response: any = await getLegalEntityMappings();
        let codes = response?.codes;
        setTableValues(codes);
   }

    const clearForm = () => {
        setNewList([]);
        setDeletedList([]);
        setMappingList([]);
        setAddValueText("");
        setAddMappingText("");
        setButtonDisabled(true);
        setTableValues([]);
        setSelectedTableValue({});
        setSelectedSegmentValue({});
        let input: HTMLInputElement;
        input = document.getElementById("searchInput") as HTMLInputElement;
        input.value = "";
        var element = document.getElementById("bAdd");
        element?.classList.add("add-disabled");
        element?.classList.remove("add");
        var element2 = document.getElementById("records")
        if (element2) {
            element2.innerHTML = "";
        }
    }

    const saveForm = async () => {
        let tableName = selectedTable;
        let displayName = selectedTableName;
 
        if (!tableName) {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Please select a drop down before proceeding.",
                life: 4000,
            });
            return;
        }   
  
        if (newList?.length || deletedList?.length) {
            var tableDetails = {
                'TableName': tableName,
                'Additions': newList,
                'Deletions': deletedList
            };
    
            let BASE_URL =  process.env.REACT_APP_API_URI;
            let url=BASE_URL + MANAGEDROPDOWN_URL;
       
            const res:any = await new Promise((resolve, reject) => {
            try {
            axios.postRequest(url, tableDetails) 
                .then((res: any) => {
                    setShowLoader(false);
                    setSpinnerClassName('divSpinner');
                    resolve(res);
                })
                .catch((err: any) => {
                    setShowLoader(false);
                    setSpinnerClassName('divSpinner');
                    resolve(err);
                });
            } catch (error) {
                setShowLoader(false);
                setSpinnerClassName('divSpinner');
                reject(error);
            }
            }); // end res:any

            if (res.status === "Success") {
                setNewList([]);
                setDeletedList([]);
                setMappingList([]);
                setAddValueText("");
                setAddMappingText("");
                setButtonDisabled(true);
                let input: HTMLInputElement;
                input = document.getElementById("searchInput") as HTMLInputElement;
                input.value = "";
                var element = document.getElementById("bAdd");
                element?.classList.add("add-disabled");
                element?.classList.remove("add");
                //refresh list of values for selected table
                if (tableName === "legal_entities") {
                    let response: any = await getLegalEntityMappings();
                    let codes = response?.codes;
                    setTableValues(codes);
                } else {
                    let response: any = await getAdminDropdownValues(tableName);
                    let codes = response?.codes;
                    setTableValues(codes);

                    if (tableName === "segments") {
                        //reload to pick up any new segments
                        loadSegmentDropDonwList();
                    }
                }
                 toast.current?.show({ severity: 'success', summary: displayName + ' updated!', closable: true });
            }
            else {
                toast.current?.show({sticky: true, severity: 'error', summary: 'Unable to update ' + displayName, closable: true });
            }          
        }else {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Please add a value before proceeding.",
                life: 4000,
            });
        }
    }

    const addToNewValuesDropDown = () => {
        let alreadyExists = false;
        let findItem = false;
     
        if (addValueText) {
            let searchText = addValueText;
            setLastValueText(addValueText);

            if (selectedTable === "legal_entities" || selectedTable === "total_clients_by_manager" || selectedTable === "segment_attributes") {
                for (let i = 0; i < tableValues.length; i++) {
                    var origName = tableValues[i].name;
                    let searchValue = origName.split('->');
                    searchText = searchValue[0].trim();

                    if (searchText === addValueText) {
                        findItem = true;
                        break;
                    }
                }
            }else {
                findItem = tableValues.find((item) => item["name"] === addValueText);           
            }

            if (!findItem) {
                alreadyExists = newList.toString().includes(addValueText);
                // if the item is not in new list add it
                if (!alreadyExists) {
                    let newItem = [...newList, addValueText];
                    //show mapping dialiog for Legal Entities
                    if (selectedTable === "legal_entities") {
                        setNewList(newItem);
                        setDialogVisible(true);
                    }else if (selectedTable === "segment_attributes" || selectedTable === "total_clients_by_manager") {
                        setNewList(newItem);
                        setSegmentDialogVisible(true);
                    }
                    else {
                        setNewList(newItem);
                    }
                } else {
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: "'" + addValueText + "' is already in the new values list",
                        life: 4000,
                      });
                  }
            }else {
                toast.current.show({
                    severity: "error",
                    summary: "Error",
                    detail: "'" + addValueText + "' is already a value in the drop down",
                    life: 4000,
                  });
            }
       }
       setAddValueText("");
       setButtonDisabled(true);
       var element = document.getElementById("bAdd");
       element?.classList.add("add-disabled");
       element?.classList.remove("add");
    }

//    const setSelectedValue = (e: { value: any}) => {
//         setSelectedOption(e["name"]);
//    }

    const handleAdd = (event: any) => {
        const addText = event.target.value;
        setAddValueText(addText);
        var element = document.getElementById("bAdd");

        if (addText) {
            setButtonDisabled(false);
            element?.classList.remove("add-disabled");
            element?.classList.add("add");
        }else {     
            setButtonDisabled(true);
            element?.classList.add("add-disabled");
            element?.classList.remove("add");
        }
    };

    const handleAddMapping = (event: any) => {
        const addMappingText = event.target.value;
        setAddMappingText(addMappingText);      
    };

    const addToMappingList = () => {
        if (addMappingText) {
            var newIdx = (newList.length - 1);
 
            if (newIdx >= 0) {
                newList[newIdx] +=  " -> " + addMappingText;
            }

            setDialogVisible(false);
         } else {
            var errMsg = "Please enter a mapping value before proceeding.";
            if (selectedTableName === "Segment Attribute" || selectedTableName === "Total Clients - By Manager") {
                errMsg = "Please select a segment mapping before proceeding.";
            }
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errMsg,
                life: 4000,
              });
        }
    }

    const addToSegmentMappingList = () => {
        if (addMappingText) {
            var newIdx = (newList.length - 1);
 
            if (newIdx >= 0) {
                newList[newIdx] +=  " -> " + addMappingText;
            }

            setSegmentDialogVisible(false);
            setSelectedSegmentValue({});
         } else {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Please select a segment mapping before proceeding.",
                life: 4000,
              });
        }
    }

    const reject = () => {
        setVisible(false);
    }

  useEffect(() => {
    setButtonDisabled(true);
    loadDropDownList();
    loadSegmentDropDonwList();
   }, []);

   
 const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    let _filters = { ...filters };

    // @ts-ignore
    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
};

 const renderHeader = () => {
    return (
        <div className="flex justify-content-end">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                
            </span>
        </div>
    );
};

function cancelMapping() {
    setDialogVisible(false);
    setSegmentDialogVisible(false);
    const index = newList.indexOf(lastValueText);
    if (index > -1) { // only splice array when item is found
        newList.splice(index, 1); // 2nd parameter means remove one item only
      }
}

 function Callback(mappings: any) {
    setTableValues(mappings);
  }

  function searchFunction(): void {
    let input: HTMLInputElement;
    let filter: string;
    let table: HTMLTableElement;
    let tr: HTMLCollectionOf<HTMLTableRowElement>;
    let td: HTMLTableCellElement | null;
    let txtValue: string;
  
    input = document.getElementById("searchInput") as HTMLInputElement;
    filter = input.value.toUpperCase();
    table = document.getElementById("records") as HTMLTableElement;
    tr = table.getElementsByTagName("tr");
   
    for (let i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0] as HTMLTableCellElement;
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }       
    }
  }
const header = renderHeader();
   

    return (
       
        <div className="row m-5 mt-4">
            <div className="col-md-12">
                <Toast ref={toast} />
                <ConfirmDialog
                    visible={visible}
                    onHide={() => setVisible(false)}
                    message="Are you sure you want to proceed?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={saveForm}
                    reject={reject}
                    style={{ width: '30vw' }}
                    breakpoints={{ '1100px': '75vw', '960px': '100vw' }}
                />
                <Dialog header="Enter Total Clients - Contracted by Country mapping" visible={dialogVisible} style={{ width: '50vw' }} onHide={() => cancelMapping()}>
                    <div className="flex flex-column px-8 py-5 gap-4" style={{ borderRadius: '12px' }}>
                           <div className="inline-flex flex-column gap-2">
                              <InputText  style={{ width:"520px" }}
                                id="iNewMapping"  
                                className="bg-white-alpha-20 border-none p-3 text-primary-50"
                                placeholder="Enter New Mapping Value"
                                onChange={handleAddMapping}
                            >
                            </InputText>
                        </div><br/>
                         <div className="flex align-items-center gap-2">
                            <Button label="Continue" onClick={() => addToMappingList()} className="p-3 w-full text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10 save"></Button>&nbsp;&nbsp;
                            <Button label="Cancel" onClick={() => cancelMapping()} className="p-3 w-full text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"></Button>
                        </div>
                    </div>
                
                </Dialog>
                <Dialog header="Select Segment mapping" visible={segmentDialogVisible} style={{ width: '50vw' }} onHide={() => cancelMapping()}>
                    <div className="flex flex-column px-8 py-5 gap-4" style={{ borderRadius: '12px' }}>
                           <div className="inline-flex flex-column gap-2">
                           <Dropdown className="dd-style" id="dSegmentDropdownList" filter value={selectedSegmentValue} options={segments}  onChange={onSegmentTableChange} optionLabel="name" placeholder="Select segment mapping" />
                        </div><br/>
                         <div className="flex align-items-center gap-2">
                            <Button label="Continue" onClick={() => addToSegmentMappingList()} className="p-3 w-full text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10 save"></Button>&nbsp;&nbsp;
                            <Button label="Cancel" onClick={() => cancelMapping()} className="p-3 w-full text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"></Button>
                        </div>
                    </div>
                
                </Dialog>
                <h4 className="mb-5">Drop Down Management</h4>
                <div>
                    <div className='child'>
                        <span className="p-float-label w-full md:w-14rem">
                        <Dropdown className="dd-style" id="dDropdownList"filter value={selectedTableValue} options={dropdownTables}  onChange={onTableChange} optionLabel="name" placeholder="Select dropdown to manage" />
                        {/* <label htmlFor="dd-dDropdownList">Select dropdown</label> */}
                        </span>
                    </div>
                    <div className='child'>
                        <Button type="button" id="bClearForm" label="Clear Form" onClick={() => clearForm()}  className="p-button-secondary clear"/>
                    </div>


                </div><br/>          
                <span><i>&nbsp;&nbsp;<b>Please note:</b> Toggling the status will immediately update the database.</i></span>
                <br/><br/>
                <div style={{ display:"flex", overflowY :"hidden"}}>
                 <div className='child-table'>
                 <input type="text" id="searchInput" onKeyUp={searchFunction} placeholder="Search for a value..." title="Type in any value"/>
                    <div className="table-wrapper">
                         {tableValues && tableValues.length > 0 ? (
                        <div id="dRowsx" >                    
                            <ToggleSwitch  tableData={tableValues} tableName={selectedTable} updateFunc={updateFunc} handleCallback={Callback}></ToggleSwitch>
                         </div>
                        
                        ) : 
                        <div id="dRowsx" >
                        <table id='records'>
                        <tbody><tr><th>Value</th><th>Status</th><th>Last Updated</th></tr></tbody>
                        </table>
                        </div>
                         }  
                    </div>
                    <br/>
 
                </div>
                <div className='child6'>
                <span><b>Enter new value</b></span>
                        <InputText style={{ width:"520px" }}
                            id="addText"
                            name="addText"
                            value={addValueText}
                            placeholder="Enter New Value"
                            onChange={handleAdd}
                        />
                        <br/><span><b>Values To Be Added</b></span><br/><ListBox id="NewValues"  emptyMessage=" " options={newList}  listStyle={{ width: '520px', height: '270px' }} /> 
                        <br/>
                        <Button type="button" id="bCancel" label="Cancel" onClick={() => clearForm()}  className="p-button-secondary cancel"/>&nbsp;&nbsp;<Button type="button" id="bSave" label="Save Changes" onClick={() => setVisible(true)}  className="p-button-secondary save"/>
                    </div>
                    <div className="child-add">
                        <Button type="button" id="bAdd" label="+" onClick={() => addToNewValuesDropDown()}  className="p-button-secondary add-disabled"/>
                     </div>                  
                </div>
            </div>
          </div>
    )
}